import Calendario from '../../spa/calendario/Calendario';

export default {
  path: 'calendario',
  name: 'calendario',
  component: Calendario,
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/config/router/calendario.js